import { useCallback } from 'react';
import {
  NavigateOptions,
  To,
  useLocation,
  useNavigate,
} from 'react-router-dom';

interface AppNavigateFunction {
  (to: To, options?: NavigateOptions): void;
  (delta: number, options?: { fallback?: string }): void;
}

const useAppNavigate = () => {
  const location = useLocation();

  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle
  const _navigate = useNavigate();

  const navigate: AppNavigateFunction = useCallback((to: any, options: any) => {
    if (typeof to === 'number') {
      if ((window as any)?.ReactNativeWebView) {
        (window as any).ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'NAVIGATE',
            metadata: { back: true },
          }),
        );
        return;
      }
      if (
        options &&
        options?.fallback &&
        to < 0 &&
        location.key === 'default'
      ) {
        _navigate(options.fallback, { replace: true });
        return;
      }
      _navigate(to);
    } else {
      if ((window as any)?.ReactNativeWebView) {
        (window as any).ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'NAVIGATE',
            metadata: { path: to },
          }),
        );

        return;
      }
      _navigate(to, options);
    }
  }, []);

  return navigate;
};

export default useAppNavigate;
